<template>
  <div class="el-col el-col-24">
    <div class="el-form-item el-form-item--small">
      <label class="el-form-item__label">
        <span>{{name}}</span>
      </label>
      <div class="el-form-item__content">
        <el-upload
          validateevent="true"
          class="upload-demo"
          action="https://jsonplaceholder.typicode.com/posts/"
          :on-remove="handleRemove"
          :on-change="handleChange"
          multiple
          :http-request="uploadFile"
          :file-list="fileList">
          <div class="addFile">
            <i class="el-icon-plus"></i>
          </div>
        </el-upload>
      </div>
    </div>
  </div>
</template>

<script>
import oss from '@/request/oss.js'
export default {
  name: "index",
  data(){
    return{
      name:'默认',
      fileList:[],
      file:[]
    }
  },
  methods:{
    handleChange(file,list){
      this.fileList = list
    },
    uploadFile(param){
      let that = this;
      oss("/cms/customer/", param.file, function (res,url) {
        that.file.push(url)
        that.$message({
          message: '上传成功',
          type: 'success'
        })
        //成功
      });
    },
    handleRemove(file,list){
      console.log(this.fileList)
      for (let i = 0; i < this.fileList.length; i++) {
        if(this.fileList[i].uid==file.uid){
          this.file.splice(i,1)
          console.log(i)
        }
      }
      console.log(file)
      console.log(this.file)
      this.fileList = list
    }
  }
}
</script>

<style scoped>
.addFile{
  width: 100px;
  height: 100px;
  border: 1px dashed #ccc;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/component/extra/index.vue